"use client";
import { useSearchParams } from "next/navigation";
import { IBlogsCategory } from "@/api/AppApi/services/blogs/interfaces/IBlogs";
import CustomButton, {
  BtnRadius,
  BtnSizes,
  BtnTypes,
} from "@/app/components/lib/CustomButton";
import TabsSlider from "@/app/components/lib/Embla-tabs-slider/TabsSlider";
import { useTranslation } from "@/hooks/localization/useTranslations";
import { useBlogPushQuery } from "@/utils/functions/useBlogPushQuery";
import NextImage from "@/app/components/lib/NextImage";

interface Props {
  blogCategories: IBlogsCategory[];
}
const BlogCategories: React.FC<Props> = ({ blogCategories }) => {
  const statusQuery = "category";
  const searchParams = useSearchParams();
  const { pushQueryToRouter } = useBlogPushQuery();
  const t = useTranslation();
  const allStatus = blogCategories;
  const statusTypes: (IBlogsCategory | { key: string; value: string; blogs_count: number })[] = [
    { key: "null", value: t.all, blogs_count: 0 },
    ...allStatus,
  ];
  const selectedKey = searchParams?.get(statusQuery) ?? "null";
  const selectedIndex = statusTypes.findIndex((st) => st.key == selectedKey);

  const handleCategoryClick = (key: string) => {
    pushQueryToRouter(
      [{ name: statusQuery, val: key === "null" ? "" : key }],
      true
    );
  };

  return (
    <div style={{ width: "100%", maxWidth: "100%", overflow: "hidden" }}>
      <TabsSlider spacing={6} selectedIndex={selectedIndex}>
        {statusTypes.map((statusType) => (
          <div
            key={statusType.key}
            onClick={() => handleCategoryClick(statusType.key)}
            style={{ cursor: "pointer" }}
          >
            <CustomButton
              type={
                selectedKey === statusType.key
                  ? BtnTypes.primary
                  : BtnTypes.neutral
              }
              size={BtnSizes.option}
              radius={BtnRadius.large}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                }}
              >
                {"image_url" in statusType && statusType.image_url && (
                  <NextImage
                    src={statusType.image_url}
                    alt={statusType.value}
                    width={24}
                    height={24}
                    style={{ borderRadius: "50%", objectFit: "cover" }}
                  />
                )}
                <span>{statusType.value}</span>
              </div>
            </CustomButton>
          </div>
        ))}
      </TabsSlider>
    </div>
  );
};

export default BlogCategories;
